import { classnames } from 'tailwindcss-classnames';
import TransplantsContentBlock from './_transplantsContentBlock';
import { TransplantsContentBlockContainerProps } from './_types';

const TransplantsContentBlockContainer = ({
  displayYears,
  totals,
  program,
  index,
  count,
}: TransplantsContentBlockContainerProps) => {
  const years =
    displayYears.length > 0
      ? {
          startYear: displayYears[0].name,
          endYear: displayYears[displayYears.length - 1].name,
        }
      : {
          startYear: '',
          endYear: '',
        };
  return (
    <>
      <TransplantsContentBlock
        transplantTotals={totals[program]}
        startYear={years.startYear}
        endYear={years.endYear}
        adultFlag={program === 'adult'}
      />
      {count > 1 && index < count - 1 && <hr className={classnames('mb-0', 'sm:mb-7')} />}
    </>
  );
};

export default TransplantsContentBlockContainer;
